module.exports = __webpack_public_path__ + "static/media/logos6.c273b447.png";